// extracted by mini-css-extract-plugin
export default {"datetime":"eWchVzV"};